import React from "react";
import { Typography } from "@mui/material";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";
import { useIsCargoOpsShippingAgent } from "../hooks/useIsCargoOpsShippingAgent";
import { useOperationNominations } from "../hooks/useOperationNominations";
import NominationLinks from "./NominationLinks";

const OperationNominations: React.FC<{ operationId: string }> = ({ operationId }) => {
  const { t } = useTranslation();
  const isShippingAgent = useIsCargoOpsShippingAgent();
  const isOperationsUser = useAuthStore((state) => state.isOperationsUser);
  const allowed = isShippingAgent || isOperationsUser;
  const query = useOperationNominations(operationId, allowed);

  if (!allowed || query.isLoading) {
    return null;
  }
  if (query.isError) {
    return (
      <Typography
        variant="caption"
        color="text.secondary"
        data-testid="drybulk-nominations-unavailable"
      >
        {t(`${DRYBULK_CARGO_OPS_LANG_BASE}.nominations-unavailable`)}
      </Typography>
    );
  }
  return <NominationLinks nominations={query.data?.nominations ?? []} />;
};

export default OperationNominations;
